import { LocalStorageKeys } from '@/types';
export default (function (_a) {
    var route = _a.route;
    if (route.fullPath.startsWith('/companies')) {
        localStorage.setItem(LocalStorageKeys.LastURL, route.fullPath);
    }
});
